// extracted by mini-css-extract-plugin
export default {"top__header":"Auth_top__header__MsgD5","container":"Auth_container__O-hwO","login__card":"Auth_login__card__GU+pm","panel":"Auth_panel__r+aMV","logo":"Auth_logo__ZeO6W"};